export const refundPolicyContent = {
  'zh-CN': {
    title: '退款政策',
    lastUpdated: '最后更新：2025年11月12日',
    description:
      'RQuant 始终与客户站在一起。当平台提供的模拟指标未达到基本表现时，我们会主动提供补偿与退款选项，确保您的权益得到保障。',
    sections: [
      {
        id: 'commitment',
        title: '一、我们的承诺',
        paragraphs: [
          '我们与客户站在一起，将产品表现与用户体验放在首位。当模拟策略的核心指标出现明显偏差时，我们会第一时间启动补偿机制，避免您为无效服务付费。'
        ]
      },
      {
        id: 'abnormal-metrics',
        title: '二、异常指标判定',
        paragraphs: [
          '若连续 120 天内，平台提供的模拟策略总收益低于 0，且同期整体平均胜率低于 50%，即认定为“指标异常”状态。该判定以平台展示的汇总数据为准，并会在用户中心同步提示。'
        ]
      },
      {
        id: 'compensation-options',
        title: '三、指标异常时的补偿方案',
        paragraphs: [
          '一旦触发指标异常，我们会立即启动以下两项措施，以保障您的订阅权益：'
        ],
        list: [
          {
            title: '服务期冻结：',
            body: '用户剩余服务期将在异常期间自动冻结，不计入消耗。直至指标恢复正常后，服务期才会开始继续计时。'
          },
          {
            title: '退款选择：',
            body: '您也可以在指标异常期间主动发起退款申请，我们将退还所有指标异常天数对应的费用，并同时退还尚未开始消费的未来服务天数费用。'
          }
        ]
      },
      {
        id: 'after-recovery',
        title: '四、指标恢复后的选择',
        paragraphs: [
          '当模拟收益重新回到 0 以上且胜率不低于 50%，指标被视为恢复正常。此时：'
        ],
        list: [
          {
            title: '继续使用：',
            body: '冻结的剩余服务期将自动解冻并继续计时，您可继续享受服务。'
          },
          {
            title: '退款限制：',
            body: '指标恢复后将不再受理新的退款申请。系统会自动解冻冻结的服务期，并结合补偿政策（如异常天数翻倍延期）继续履行剩余订阅。'
          }
        ]
      },
      {
        id: 'example',
        title: '五、示例说明',
        paragraphs: [
          '以年付订阅的香港市场用户为例：用户从 3 月 1 日开始使用，至 7 月 1 日期间，香港市场的模拟收益持续低于 0，且整体平均胜率低于 50%，直至 7 月 2 日指标恢复正常。'
        ],
        list: [
          {
            title: '退款窗口：',
            body: '从第 121 天起（6 月 29 日），用户可以主动提交退款申请，系统也会自动冻结剩余服务天数。若在 7 月 2 日指标恢复正常前提交申请，可退还 3 月 1 日以来全部服务天数的费用以及尚未开始的剩余天数费用。7 月 2 日之后将无法再主动发起退款。退款申请表单的提交时间视为正式申请时间，即使表单内容需要补充也不影响窗口资格。'
          },
          {
            title: '延长期限：',
            body: '如果用户未发起退款，平台会提供异常天数两倍的服务延期作为补偿。本例中异常持续 123 天，用户将获赠 246 天的额外服务期。'
          }
        ],
        closing: [
          '该示例用于阐明退款与补偿的触发条件和时间节点，实际处理以平台实时数据与客服核对结果为准。'
        ]
      },
      {
        id: 'apply-steps',
        title: '六、退款申请流程',
        list: [
          '通过站内工单、客服邮箱或专属服务代表提交退款申请，附上账号信息。',
          '客服团队将在 2 个工作日内完成指标核对并确认可退金额。',
          '退款将在确认后的 5 个工作日内原路退回；若无法原路退回，将与您确认其他安全渠道。'
        ],
        closing: [
          '如您对退款结果或金额存在疑问，可再次提交反馈，我们会在 3 个工作日内回复并提供进一步解释。'
        ]
      },
      {
        id: 'contact',
        title: '七、联系我们',
        paragraphs: [
          '若您在退款政策执行过程中遇到任何问题，可通过平台反馈中心或 support@eyuanquant.com 与我们联系。我们将尽全力保障您的权益。'
        ]
      }
    ]
  },
  'en-US': {
    title: 'Refund Policy',
    lastUpdated: 'Last updated: November 12, 2025',
    description:
      'At RQuant we stand with our clients. When the simulated indicators delivered by the platform fall short, we proactively offer compensation and refund options to protect your subscription value.',
    sections: [
      {
        id: 'commitment',
        title: '1. Our Commitment',
        paragraphs: [
          'We are on the client’s side and prioritise product performance and user experience. Whenever the core metrics of our simulated strategies deviate materially, we immediately activate the compensation mechanism so you never pay for ineffective service.'
        ]
      },
      {
        id: 'abnormal-metrics',
        title: '2. Definition of Abnormal Indicators',
        paragraphs: [
          'If, over any rolling 120-day period, the aggregated simulated return provided by the platform is below 0 and the overall average win rate during the same window falls below 50%, the service is considered to be in an “abnormal indicator” state. This assessment is based on the platform dashboards and will be displayed in your account area.'
        ]
      },
      {
        id: 'compensation-options',
        title: '3. Compensation While Indicators Are Abnormal',
        paragraphs: [
          'Once the abnormal condition is triggered we immediately implement both of the following safeguards for your subscription:'
        ],
        list: [
          {
            title: 'Service freeze:',
            body: 'Your remaining subscription term is frozen for the duration of the abnormal period and no time is consumed. The countdown resumes only after the indicators are back within normal thresholds.'
          },
          {
            title: 'Refund option:',
            body: 'You may request a refund at any point during the abnormal period. We will refund all fees corresponding to the abnormal days plus any unused future service days.'
          }
        ]
      },
      {
        id: 'after-recovery',
        title: '4. Options After Recovery',
        paragraphs: [
          'When simulated returns return above 0 and the win rate is at least 50%, the indicators are deemed recovered. At that time you may:'
        ],
        list: [
          {
            title: 'Continue the service:',
            body: 'The previously frozen term automatically resumes and you can keep using the platform as scheduled.'
          },
          {
            title: 'Refund limitation:',
            body: 'No new refund requests are accepted once indicators return to normal. The frozen term resumes automatically and any service extensions (for example, the abnormal-days ×2 credit) continue under your subscription.'
          }
        ]
      },
      {
        id: 'example',
        title: '5. Example Scenario',
        paragraphs: [
          'Consider an annual subscriber focused on the Hong Kong market. The subscription starts on 1 March and, through 1 July, the simulated return remains below 0 while the overall average win rate stays under 50%. On 2 July the indicators recover to normal.'
        ],
        list: [
          {
            title: 'Refund window:',
            body: 'Beginning on day 121 (29 June) the user may submit a refund request. The system automatically freezes the remaining term at that point. If the request is submitted before indicators recover on 2 July, the user can receive a refund covering all service days since 1 March plus any unused future days. After 2 July the user can no longer initiate a refund. The timestamp of the refund form submission is treated as the official initiation, even if additional information is requested later.'
          },
          {
            title: 'Extended access:',
            body: 'If the user does not request a refund, the platform grants an extension equal to twice the number of abnormal days. In this case the abnormal period lasted 123 days, so the user receives 246 additional service days.'
          }
        ],
        closing: [
          'This scenario illustrates how the refund and compensation mechanisms are triggered. Actual handling follows real-time platform metrics and the verification performed by our support team.'
        ]
      },
      {
        id: 'apply-steps',
        title: '6. How to Request a Refund',
        list: [
          'Submit a refund ticket through the in-product support centre, by email, or via your dedicated account representative and include your account details.',
          'Our support team will verify the indicators and confirm the refundable amount within two business days.',
          'Approved refunds are returned via the original payment method within five business days. If the original method is unavailable, we will coordinate an alternative secure channel with you.'
        ],
        closing: [
          'If you have any questions about the refund results or amounts, please contact us again. We will respond within three business days with additional clarification.'
        ]
      },
      {
        id: 'contact',
        title: '7. Contact Us',
        paragraphs: [
          'For any questions while this refund policy is being applied, reach out via the platform feedback centre or email support@eyuanquant.com. We will do everything we can to protect your rights.'
        ]
      }
    ]
  }
};
